import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Project } from '../../../shared/models/project';

@Injectable({
  providedIn: 'root'
})
export class ProjectLandingDataService {

  private projectDataSource = new Subject<Project>();
  public projectData$ = this.projectDataSource.asObservable();

  public projectData(data: Project) {
    this.projectDataSource.next(data);
  }
}